// extracted by mini-css-extract-plugin
export default {"MySubscriptionWrapper":"my-subscriptions_MySubscriptionWrapper__927gF","ListWrapper":"my-subscriptions_ListWrapper__U84DF"};